<template>
  <div class="product">

    <a-spin :spinning="loading" >
      <div class="content-wrap" >
        <div class="content-main">
          <div class="filterBarWrap">
            <div class="filterBar" ref="marketplaceRef">
              <div class="filterBar-left">
               <div class="item">
                <span>Marketplace:</span>
                <artmisads-select
                  style="width: 232px"
                  v-model:value="associateParams.marketplace"
                  :getPopupContainer="() => marketplaceRef"
                  :options="COUNTRY_BASE_OPTIONS"
                  @change="handleChangeMarketplace"
                />
              </div>
              <div class="item">
                <span>Sales Time:</span>
                <a-range-picker
                  :presets="RANGE_PRESETS"
                  v-model:value="associateParams.salesTime"
                  format="YYYY-MM-DD"
                  @change="handleSalesTime"
                />
              </div>
              </div>
             <!-- <div class="filterBar-right">
                <artmisads-button-special  @click="exportData" :isSquare="true"
            type="primary" >Export</artmisads-button-special>
            <a-dropdown :getPopupContainer="() => marketplaceRef">
          <template #overlay>
            <artmisads-dropdown-menu @click="handleExportClick">
              <a-menu-item key="all">Export All Data</a-menu-item>
              <a-menu-item key="filter">Export with Filters</a-menu-item>
            </artmisads-dropdown-menu>
          </template>
          <artmisads-button-special>
            <svg class="icon daochu" aria-hidden="true">
              <use xlink:href="#icon-daochu"></use>
            </svg>
            <span class="btn-text">Export</span>
            <svg class="icon artmisads-select-down-icon" aria-hidden="true">
              <use xlink:href="#icon-jiantou-xia-cu"></use>
            </svg>
          </artmisads-button-special>
        </a-dropdown>
             </div> -->
            </div>
          </div>
          <associateTags
            :totalParams="associateTotalParams"
            :currency="currency"
          />
          <div class="table">
            <artmisads-table
              :columns="columns"
              row-key="id"
              :data-source="associateDataList"
              :pagination="{
                total: associateListTotal,
                current: associateParams.page,
                pageSize: associateParams.size,
                showSizeChanger: true,
              }"
              :loading="loading"
              :change="onChangePage"
              rowClassName="table-item"
              tableLayout="fixed"
              :scroll="{ y: tableScrollHeight }"
            >
              <template #bodyCell="{ column, record, text }">
                  <template v-if="column.name === 'showCurrency'">
          {{text ? currency  : ''}}{{text}}
        </template>
                <template v-if="column.dataIndex === 'salesTime'">
                  {{ moment(record.reportDateTimestamp).format('YYYY-MM-DD') }}
                </template>
              </template>
            </artmisads-table>
          </div>
        </div>
      </div>
    </a-spin>
  </div>
</template>
<script lang="jsx" setup>
import moment from 'moment'
import { onMounted, ref, computed, nextTick,defineEmits } from 'vue'
import { publisherAdminApi } from '~/server/index'

import associateTags from './associateTags.vue'

import { AMAZON_CURRENCY_MAPPER } from '~/contants/common'

import { COUNTRY_BASE } from '~/contants/common'
import { useTableScrollHeight } from '@/utils/useTableScrollHeight'
import { RANGE_PRESETS } from '~/contants/reports'
const emit = defineEmits(['save']);

const associateListTotal = ref(0)
const associateDataList = ref([])
const columns = ref([
  {
    title: 'Sales Time',
    dataIndex: 'salesTime',
    key: 'salesTime',
  },
  {
    title: 'Marketplace',
    dataIndex: 'marketplace',
    key: 'marketplace',
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    key: 'quantity',
  },
  {
    title: 'Sales',
    dataIndex: 'salesAmount',
    key: 'salesAmount',
     name: 'showCurrency',
  },
  {
    title: 'commissions',
    dataIndex: 'commissions',
    key: 'commissions',
     name: 'showCurrency',
  },
  {
    title: 'Media Commissions',
    dataIndex: 'commissionAmount',
    key: 'commissionAmount',
     name: 'showCurrency',
  },
  {
    title: 'Platform Commissions',
    dataIndex: 'platformFeeAmount',
    key: 'platformFeeAmount',
     name: 'showCurrency',
  },
])
const { tableScrollHeight } = useTableScrollHeight({
  selector: '.table',
  bottomSpace: 260,
  minHeight: 200,
  maxHeight: 1000,
  defaultHeight: 350,
})

const marketplaceRef = ref(null)

const activeTab = ref('0')

const loading = ref(true)

const associateTotalParams = ref({
  totalCommissionAmount: 0,
  totalCommissionAndFeeAmount: 0,
  totalPlatformFeeAmount: 0,
  totalSalesAmount: 0,
})
const COUNTRY_BASE_OPTIONS = COUNTRY_BASE.map((item) => {
  item.value = item.host
  item.label = item.host
  return item
})
const associateParams = ref({
  marketplace: 'amazon.com',
  page: 1,
  size: 10,
  salesTime: [
    moment(moment().subtract(7, 'day').startOf('day').valueOf()),
    moment(moment().startOf('day').valueOf()),
  ],
  startReportDateTimestamp: moment()
    .subtract(7, 'day')
    .startOf('day')
    .valueOf(),
  endReportDateTimestamp: moment().startOf('day').valueOf(),
})


const currency = computed(() => {
  const data = AMAZON_CURRENCY_MAPPER[associateParams.value.marketplace]
  return data
})

const handleChangeMarketplace = () => {
  associateParams.value.page = 1
  associateParams.value.size = 10
  getAssociateCommissionReportsAgg()
  getAssociateList()
  emit('save',associateParams.value)
  // params.value.marketplace=associateParams.value.marketplace
}
const handleSalesTime = (value) => {
  associateParams.value.startReportDateTimestamp = value[0].valueOf()
  associateParams.value.endReportDateTimestamp = value[1].valueOf()
  associateParams.value.page = 1
  associateParams.value.size = 10
  getAssociateCommissionReportsAgg()
  getAssociateList()
  emit('save',associateParams.value)
}
const handleExportClick=({ key })=>{
  let param={}
  // console.log(key,'数据')
  if (key == 'all') {
    param={
     endReportDateTimestamp: moment().endOf('day').valueOf(),
      startReportDateTimestamp: moment().subtract(360, 'day').startOf('day').valueOf(),
    }
  }else{
    param={
      marketplace: associateParams.value.marketplace,
      startReportDateTimestamp: associateParams.value.startReportDateTimestamp,
      endReportDateTimestamp: associateParams.value.endReportDateTimestamp,
      page: associateParams.value.page,
      size: associateParams.value.size,
    }
  }
  publisherAdminApi.associateCommissionReportsPerformanceExport({
    qs: param,
    fileName: `associate_commission_reports_${moment().format('YYYY-MM-DD')}.csv`,
    platform: 'operator',
  })
}

const onChangePage = (data, filters, sorter) => {
  associateParams.value.page = data.current
  associateParams.value.size = data.pageSize
  getAssociateList()
}
const getAssociateCommissionReportsAgg = async () => {
  loading.value = true
  const res = await publisherAdminApi.associateCommissionReportsAgg(
    associateParams.value
  )
  if (res) {
    associateTotalParams.value = res
  }
  loading.value = false
}
const getAssociateList = async () => {
  loading.value = true
  const res = await publisherAdminApi.associateCommissionReportsPerformance(
    associateParams.value
  )
  if (res) {
    const { data, total } = res
    associateDataList.value = data
    associateListTotal.value = total
  }
  nextTick(() => {
    loading.value = false
  })
}

onMounted(async () => {
  await getAssociateCommissionReportsAgg()
  await getAssociateList()
})
</script>
<style lang="less" scoped>
.product {
  padding: 0 16px 16px;
}
.content-main {
  overflow: hidden;
  border-radius: 8px;
  background-color: var(--color-white);
  box-shadow: var(--section-box-shadow-6);
}
.filterBarWrap {
  padding: 16px;
}
.table {
  padding: 16px;
}
.filterBar {
  padding: 16px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8f7fc;
  border-radius: 8px;
  .filterBar-left, .filterBar-right {
    display: flex;
    gap: 16px;
 
  }
  .filterBar-right{
    flex: 1;
    justify-content: flex-end;
  }
  .item {
    display: flex;
    gap: 6px;
    align-items: center;
  }
}
.filterBox {
  display: flex;
  gap: 16px;
  .filterItem {
    background: #f8f7fc;
    border-radius: 8px;
  }
}
</style>
